import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../../../../components/ui/card";
import { Badge } from "../../../../components/ui/badge";
import { Button } from "../../../../components/ui/button";
import { Link } from "react-router-dom";
import { Calendar, MapPin, Users, Trophy } from "lucide-react";

const UpcomingHackathon: React.FC = () => {
	const hackathonInfo = {
		title: "大船渡ハッカソン 2024 Summer",
		date: "2024年7月20日(土) - 21日(日)",
		location: "大船渡市民文化会館 マルチスペース",
		capacity: "30名（10チーム）",
		deadline: "2024年6月30日",
		prizes: [
			{
				title: "グランプリ",
				amount: "賞金30万円",
			},
			{
				title: "準グランプリ",
				amount: "賞金15万円",
			},
			{
				title: "技術賞",
				amount: "賞金5万円",
			},
		],
		theme: "地域の課題をテクノロジーで解決する",
		tags: ["地域活性化", "テクノロジー", "イノベーション"],
	};

	return (
		<section className="py-16">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-8">開催予定のハッカソン</h2>
				<Card className="bg-gradient-to-br from-purple-50 to-white">
					<CardHeader>
						<div className="flex flex-wrap gap-2 mb-4">
							{hackathonInfo.tags.map((tag) => (
								<Badge key={tag} variant="secondary">
									{tag}
								</Badge>
							))}
						</div>
						<CardTitle className="text-2xl md:text-3xl">
							{hackathonInfo.title}
						</CardTitle>
						<CardDescription className="text-lg">
							{hackathonInfo.theme}
						</CardDescription>
					</CardHeader>
					<CardContent>
						<div className="grid md:grid-cols-2 gap-8">
							<div className="space-y-4">
								<div className="flex items-center gap-2">
									<Calendar className="w-5 h-5 text-purple-600" />
									<span>{hackathonInfo.date}</span>
								</div>
								<div className="flex items-center gap-2">
									<MapPin className="w-5 h-5 text-purple-600" />
									<span>{hackathonInfo.location}</span>
								</div>
								<div className="flex items-center gap-2">
									<Users className="w-5 h-5 text-purple-600" />
									<span>{hackathonInfo.capacity}</span>
								</div>
								<div className="flex items-center gap-2">
									<Calendar className="w-5 h-5 text-purple-600" />
									<span>応募締切: {hackathonInfo.deadline}</span>
								</div>
							</div>
							<div>
								<div className="flex items-center gap-2 mb-4">
									<Trophy className="w-5 h-5 text-purple-600" />
									<span className="font-semibold">賞金・賞品</span>
								</div>
								<ul className="space-y-2">
									{hackathonInfo.prizes.map((prize) => (
										<li
											key={prize.title}
											className="flex justify-between items-center"
										>
											<span>{prize.title}</span>
											<span className="font-semibold">{prize.amount}</span>
										</li>
									))}
								</ul>
							</div>
						</div>
						<div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
							<Button asChild size="lg">
								<Link to="/hackathon/entry">エントリーする</Link>
							</Button>
							<Button asChild size="lg" variant="outline">
								<Link to="/hackathon/2024-summer">詳細を見る</Link>
							</Button>
						</div>
					</CardContent>
				</Card>
			</div>
		</section>
	);
};

export default UpcomingHackathon;
